import Help from 'assets/icons/md/md-help.svg'

Help.displayName = 'Help'
export default Help
